import { mapActions } from "vuex";
import { actions } from "@/store";

export const notificationHandlers = {
  methods: {
    ...mapActions([actions.notificationAdd]),

    displayNotification({ id, message, titleKey }) {
      this.notificationAdd({
        id,
        title: this.$t(titleKey),
        message
      });
    }
  }
};
